/**
 * Export the root application.
 */
module.exports = {
    el: "#main-wrapper",

    /**
     * The application's data.
     */
    data: {
        currentTeam: App.state.currentTeam
    }

};
